/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AddReleaseSpec } from '../model/addReleaseSpec';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { ReleaseData } from '../model/releaseData';
// @ts-ignore
import { TaskV2 } from '../model/taskV2';
// @ts-ignore
import { UpdateReleaseAccessListSpec } from '../model/updateReleaseAccessListSpec';
// @ts-ignore
import { UpdateReleaseCapabilitySpec } from '../model/updateReleaseCapabilitySpec';
// @ts-ignore
import { UpdateReleaseSpec } from '../model/updateReleaseSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class ReleaseOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Add a release to SaaSInfra
     * Add a release for a service to the SaaSInfra Release Table
     * @param addReleaseSpec Adds a release to a service
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addReleaseOperator(addReleaseSpec: AddReleaseSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public addReleaseOperator(addReleaseSpec: AddReleaseSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public addReleaseOperator(addReleaseSpec: AddReleaseSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public addReleaseOperator(addReleaseSpec: AddReleaseSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (addReleaseSpec === null || addReleaseSpec === undefined) {
            throw new Error('Required parameter addReleaseSpec was null or undefined when calling addReleaseOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/release`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: addReleaseSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a release
     * Delete the release from release table
     * @param releaseVersion Release Version.
     * @param serviceType Service Type
     * @param releasePersona Release Persona Required
     * @param cloudProvider Cloud provider
     * @param releaseType Release Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteReleaseOperator(releaseVersion: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseType?: 'GA' | 'EA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteReleaseOperator(releaseVersion: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseType?: 'GA' | 'EA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteReleaseOperator(releaseVersion: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseType?: 'GA' | 'EA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteReleaseOperator(releaseVersion: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseType?: 'GA' | 'EA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (releaseVersion === null || releaseVersion === undefined) {
            throw new Error('Required parameter releaseVersion was null or undefined when calling deleteReleaseOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling deleteReleaseOperator.');
        }
        if (releasePersona === null || releasePersona === undefined) {
            throw new Error('Required parameter releasePersona was null or undefined when calling deleteReleaseOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseVersion, 'release-version');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releasePersona, 'release-persona');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseType, 'release-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/release`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search specific release/s in SaaSInfra
     * Get details of specific release/releases for a service in the SaaSInfra Release Table
     * @param serviceType Service Type
     * @param releasePersona Release Persona Required
     * @param cloudProvider Cloud provider
     * @param releaseVersion Release Version to look for.
     * @param releaseState Release State
     * @param releaseType Release Type
     * @param upgradeFrom Upgrade From Query Param
     * @param upgradeTo Upgrade To Query Param
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReleasesOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseVersion?: string, releaseState?: 'LOADED' | 'DEFAULT' | 'AVAILABLE' | 'OBSOLETE', releaseType?: 'GA' | 'EA', upgradeFrom?: string, upgradeTo?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<ReleaseData>>;
    public getReleasesOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseVersion?: string, releaseState?: 'LOADED' | 'DEFAULT' | 'AVAILABLE' | 'OBSOLETE', releaseType?: 'GA' | 'EA', upgradeFrom?: string, upgradeTo?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ReleaseData>>>;
    public getReleasesOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseVersion?: string, releaseState?: 'LOADED' | 'DEFAULT' | 'AVAILABLE' | 'OBSOLETE', releaseType?: 'GA' | 'EA', upgradeFrom?: string, upgradeTo?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ReleaseData>>>;
    public getReleasesOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', releasePersona: 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS', cloudProvider?: 'AWS' | 'GCP', releaseVersion?: string, releaseState?: 'LOADED' | 'DEFAULT' | 'AVAILABLE' | 'OBSOLETE', releaseType?: 'GA' | 'EA', upgradeFrom?: string, upgradeTo?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling getReleasesOperator.');
        }
        if (releasePersona === null || releasePersona === undefined) {
            throw new Error('Required parameter releasePersona was null or undefined when calling getReleasesOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releasePersona, 'release-persona');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseVersion, 'release-version');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseState, 'release-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseType, 'release-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>upgradeFrom, 'upgrade-from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>upgradeTo, 'upgrade-to');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/release`;
        return this.httpClient.request<Array<ReleaseData>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modify access list of a release
     * Modify access list of a release in the SaaSInfra Release Table
     * @param updateReleaseAccessListSpec Spec to update access list of a release for a service type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateReleaseAccessListOperator(updateReleaseAccessListSpec: UpdateReleaseAccessListSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public updateReleaseAccessListOperator(updateReleaseAccessListSpec: UpdateReleaseAccessListSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public updateReleaseAccessListOperator(updateReleaseAccessListSpec: UpdateReleaseAccessListSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public updateReleaseAccessListOperator(updateReleaseAccessListSpec: UpdateReleaseAccessListSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (updateReleaseAccessListSpec === null || updateReleaseAccessListSpec === undefined) {
            throw new Error('Required parameter updateReleaseAccessListSpec was null or undefined when calling updateReleaseAccessListOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/release/access`;
        return this.httpClient.request<TaskV2>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateReleaseAccessListSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modify release capabilities
     * Modify release capabilities in the release_capability table
     * @param updateReleaseCapabilitySpec Spec to update release capabilities for a version, service, and release type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateReleaseCapabilityOperator(updateReleaseCapabilitySpec: UpdateReleaseCapabilitySpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public updateReleaseCapabilityOperator(updateReleaseCapabilitySpec: UpdateReleaseCapabilitySpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public updateReleaseCapabilityOperator(updateReleaseCapabilitySpec: UpdateReleaseCapabilitySpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public updateReleaseCapabilityOperator(updateReleaseCapabilitySpec: UpdateReleaseCapabilitySpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (updateReleaseCapabilitySpec === null || updateReleaseCapabilitySpec === undefined) {
            throw new Error('Required parameter updateReleaseCapabilitySpec was null or undefined when calling updateReleaseCapabilityOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/release/capability`;
        return this.httpClient.request<TaskV2>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateReleaseCapabilitySpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modify state/data of a release
     * Modify state/data of a release of a service in the SaaSInfra Release Table
     * @param updateReleaseSpec Spec to update state of a release for a service type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateReleaseOperator(updateReleaseSpec: UpdateReleaseSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public updateReleaseOperator(updateReleaseSpec: UpdateReleaseSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public updateReleaseOperator(updateReleaseSpec: UpdateReleaseSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public updateReleaseOperator(updateReleaseSpec: UpdateReleaseSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (updateReleaseSpec === null || updateReleaseSpec === undefined) {
            throw new Error('Required parameter updateReleaseSpec was null or undefined when calling updateReleaseOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/release`;
        return this.httpClient.request<TaskV2>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateReleaseSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
